/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IconSize } from '../../models/icon-size';

export interface IconGetIcon$Params {

/**
 * GUID of the requested icon
 */
  iconId: string;

/**
 * The desired size of the icon
 */
  size?: IconSize;
}

export function iconGetIcon(http: HttpClient, rootUrl: string, params: IconGetIcon$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, iconGetIcon.PATH, 'get');
  if (params) {
    rb.path('iconId', params.iconId, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'image/png', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

iconGetIcon.PATH = '/icon/{iconId}';
